import React, { useContext, useEffect, useState } from 'react'
import { AppSettings } from '../../config/app-settings'
import { toast } from 'react-toastify'
import Loader from '../pages/loader'
import ReusableTable from '../../components/other/ReuseableTable'
import { useGetM3uResponseMessagesQuery, useLazyGetM3uResponseMessagesQuery } from '../../redux/apis/linkManagement/m3u/lmM3uResponseMessagesApiSlice'
import EditCreateM3uResponse from '../../components/M3u/EditCreateM3uResponse'
import SearchAndFilterBar from '../../components/other/search/SearchAndFilterBar'
import DownloadAllDataButton from '../../components/other/DownloadAllDataButton'
import { can } from '../../helpers/auth'

const M3uResponseMessages = React.memo(() => {
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10
  })
  const [search, setSearch] = useState('')
  const [filters, setFilters] = useState({})

  const context = useContext(AppSettings)

  const { data, isLoading, error, isFetching } = useGetM3uResponseMessagesQuery(
    {
      expand: ['last_updated_by'].join(','),
      page: pagination.current,
      page_size: pagination.pageSize,
      ...(search ? { search } : {}),
      ...filters
    }
  )

  const [holder, setHolder] = useState()
  const [edit, setEdit] = useState(false)
  const [create, setCreate] = useState(false)

  const columns = [
    { title: 'ID', dataIndex: 'id', key: 'id', sorter: true },

    {
      title: 'MESSAGE',
      dataIndex: 'message',
      key: 'message',
      filter: true,
      filterType: 'text'
    },
    {
      title: 'MESSAGE TYPE',
      dataIndex: 'message_type',
      key: 'message_type',
      filter: true,
      filterType: 'select',
      filterOptions: [
        {
          label: 'Down',
          value: 'down'
        },
        {
          label: 'Check Again',
          value: 'check_again'
        }
      ]
    },
    {
      title: 'LAST UPDATED BY',
      dataIndex: 'last_updated_by',
      key: 'last_updated_by',
      render: text => (
        <div>
          {text?.first_name} {text?.last_name}
        </div>
      )
    },
    {
      title: 'CREATED AT',
      dataIndex: 'created_at',
      key: 'created_at',

    },
    {
      title: 'UPDATED AT',
      dataIndex: 'updated_at',
      key: 'updated_at',

    },
    {
      title: 'Actions',
      dataIndex: 'id',
      key: 'actions',
      render: (text, record) => (
        <div className='flex gap-2'>
          {can('change_m3uresponsemessages') && (
            <button
              className='btn btn-outline-theme'
              onClick={() => handleEdit(record)}
            >
              Edit
            </button>
          )}
        </div>
      )
    }
  ]

  const handleEdit = record => {
    setHolder(record)
    setEdit(true)
  }

  const handleTableChange = paginationInfo => {
    setPagination({
      current: paginationInfo.current,
      pageSize: paginationInfo.pageSize
    })
  }

  useEffect(() => {
    if (error?.data) {
      const errorMessages = Object.values(error.data).flat()
      errorMessages.forEach(message => {
        toast.error(message)
      })
    }
  }, [error])

  useEffect(() => {
    context.setAppHeaderNone(false)
    context.setAppSidebarNone(false)
    context.setAppContentClass('')
    context.setAppThemePanal(true)

    return () => {
      context.setAppHeaderNone(true)
      context.setAppSidebarNone(true)
      context.setAppContentClass('p-0')
      context.setAppThemePanal(false)
    }
  }, [context])

  return (
    <div className='w-full flex flex-col'>
      <Loader isLoading={isLoading || isFetching} />

      {can('add_m3uresponsemessages') && create && (
        <EditCreateM3uResponse
          state='create'
          open={create}
          setOpen={setCreate}
          record={null}
        />
      )}
      {can('change_m3uresponsemessages') && edit && (
        <EditCreateM3uResponse
          state='edit'
          open={edit}
          setOpen={setEdit}
          record={holder}
        />
      )}

      <div className='flex'>
        <SearchAndFilterBar
          columns={columns}
          search={search}
          setSearch={setSearch}
          filters={filters}
          setFilters={setFilters}
          setPagination={setPagination}
        />
        <div className='ml-auto flex gap-4'>
          <DownloadAllDataButton
            lazyQueryHook={useLazyGetM3uResponseMessagesQuery}
            fileName='m3u-response-msg'
          />
          {can('add_m3uresponsemessages') && (
            <button
              className='btn btn-outline-theme ml-auto mb-4'
              onClick={() => setCreate(true)}
            >
              Create New Message
            </button>
          )}
        </div>
      </div>

      <div className='row'>
        <ReusableTable
          columns={columns}
          data={data?.data?.results}
          pagination={{
            current: pagination.current,
            pageSize: pagination.pageSize,
            total: data?.data?.count,
            showSizeChanger: true
          }}
          onChange={handleTableChange}
        />
      </div>
    </div>
  )
})

export default M3uResponseMessages
